import { jsx as _jsx } from "react/jsx-runtime";
import { FavoriteHeart } from "@seeker-consumer-portal/favorite-heart";
import { useFavoriteTracking } from "@/hooks";
import { useClassifiedId } from "@/contexts/classified";
export const FavoriteCTA = ({ dark, showBorder = false, }) => {
    const classifiedId = useClassifiedId();
    const favoriteTracking = useFavoriteTracking();
    return (_jsx(FavoriteHeart, { classifiedId: classifiedId, tracking: favoriteTracking, border: showBorder, black: dark }));
};
